import { inject, Injectable } from '@angular/core';

import { UserRole } from '../enums/user-role.enum';
import { IUserClaims } from '../models/user-claims';

import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  private readonly authenticationService = inject(AuthenticationService);

  public isInRole(role: string): boolean {
    const claims = this.authenticationService.getUserClaims();

    return this.containsRole(role, claims);
  }

  public hasAnyRole(roles: string[]): boolean {
    const claims = this.authenticationService.getUserClaims();

    return !!claims?.roles && roles.some((role) => claims.roles.includes(role));
  }

  public hasOnlyRole(role: UserRole): boolean {
    const claims = this.authenticationService.getUserClaims();
    return this.containsRole(role, claims) && claims?.roles.length === 1;
  }

  private containsRole(role: string, claims: IUserClaims | null): boolean {
    return claims?.roles?.includes(role) ?? false;
  }
}
